export default __webpack_public_path__ + "static/media/simulate-desert-icon.9599ff24.png";